import {  VerifyEmailBox } from 'src/components';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle , useMediaQuery } from '@mantine/hooks';
 
import AuthWrraperGrid from 'src/components/AuthWrraperGrid/page';
const SendLinkVerify = (): JSX.Element => {
  const [t] = useTranslation('auth');

  useDocumentTitle(t('sendLinkVerifyPageTitle'));
  return (
    <AuthWrraperGrid
      leftColumn={ <VerifyEmailBox />  }
    />
  );
};

export default SendLinkVerify;